export const buildDuelTaskKey = (duelId: number, taskId: string) => `${duelId}:${taskId}`;
